<template>
  <div
    class="p-4 mt-6 z-20 shadow-xl flex justify-between items-center"
    :class="{
      'fixed -top-6 mt-0 left-0 w-full': fixed,
      'text-nucleus-white bg-nucleus-error': !warning,
      'text-nucleus-black bg-nucleus-warning': warning,
    }"
  >
    <div class="flex items-center">
      <div
        class="p-2 icon-close cursor-pointer rounded-full font-bold mr-4 h-8 w-8"
        :class="{
          'text-nucleus-error bg-nucleus-white': !warning,
          'text-nucleus-warning bg-black': warning,
        }"
        :title="$t('titles.close')"
        @click="closeError()"
      ></div>
      <div>
        <div v-if="heading" class="font-bold">{{ heading }}</div>
        <div
          v-if="content"
          :class="{
            'font-bold': !heading,
            'text-sm': heading,
          }"
        >
          {{ content }}
        </div>
      </div>
    </div>

    <div
      class="w-28 underline font-bold cursor-pointer p-2 justify-self-end"
      @click="closeError()"
    >
      {{ warning ? $t("titles.close") : $t("global.defaults.closeError") }}
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    heading: [Error, String],
    content: [Error, String],
    fixed: Boolean,
    warning: Boolean,
  },
  emits: ["closeError"],
  methods: {
    closeError() {
      this.$emit("closeError");
    },
  },
})
export default class ErrorBox extends Vue {}
</script>
